import { Button, Div, FormBuilder, Label, Loader, Touchable } from "@grassrootly/rn-core";
import { EditGroupProps } from "./EditGroup.types";
import { useEditGroup } from "./useEditGroup";
import { images } from "../../../layout/assets";
import { ImagePicker } from "../../../components/image-picker";

export default function EditGroup({ group, onEditFinished, navigation }: EditGroupProps) {
  const { profileFormState, onSubmitEdit, updating, generateJoinCode, hideForm, onNewImagePicked, newImage, onUploadCancel, copyJoinCode } = useEditGroup({
    group,
    onEditFinished,
    navigation
  });
  return (
    !hideForm ? <Div classNames={["flex1"]}>
      <ImagePicker
        onPicked={onNewImagePicked}
        classNames={["mr-{auto}", "ml-{auto}"]}
        resizeMode="cover"
        onCancel={newImage ? onUploadCancel : undefined}
        source={
          newImage
            ? { uri: newImage.uri }
            : group.group_logo
            ? { uri: group.group_logo }
            : images.groupAvatar
        }
        base64
      />
      <Div classNames={["flex1", "w100", "mt-{24}"]}>
        {profileFormState ? (
          <>
            <FormBuilder
              form={profileFormState}
              onSubmit={onSubmitEdit}
              submitControl={(submit) => (
                <>
                  {group.join_code && (
                    <Touchable onPress={copyJoinCode}>
                      <Label type="l4Regular" classNames={["colorPrimaryMain", "mt-{8}", "mb-{16}"]}>
                        Copy Join Code
                      </Label>
                    </Touchable>
                  )}
                  <Button
                    title="Generate new Join Code"
                    classNames={["btnBlock", "mt-{10}", "btnOutlinePrimary"]}
                    isLoading={updating}
                    disabled={updating}
                    type="button"
                    onPress={generateJoinCode}
                  />
                  <Button
                    title="Save"
                    classNames={["btnBlock", "mt-{10}"]}
                    isLoading={updating}
                    disabled={updating}
                    type="button"
                    onPress={submit}
                  />
                </>
              )}
            />
          </>
        ) : null}
      </Div>
    </Div>
      :
      <Div classNames={["mt-{80}"]}>
        <Loader size={'large'} isLoading={true} />
      </Div>
  );
}
